import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid, Avatar, Divider } from '@material-ui/core'
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import avatar from '../../Pics/avatar.jpg'
import ro from 'date-fns/locale/ro';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';

import "react-datepicker/dist/react-datepicker.css";
import SpecificComponent from '../SpecificComponent';

import { ReactComponent as TrashAltSolid } from '../../module/chestionare/Icoane Font Awesome/trash-alt-solid.svg'
import { ReactComponent as PenSolid } from '../../module/chestionare/Icoane Font Awesome/pen-solid.svg'
import Masks from '../../providers/Masks';
import LocalStorage from '../../providers/LocalStorage';

registerLocale('ro', ro)




export default class ConcediuDialogNew extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            editReady: false,
        }
    }

    componentDidMount() {

    }

    u = new Utils();
    ws = new Ws()
    m = new Masks()
    ls = new LocalStorage()

    numeAvatar = (nume) => {

        if (nume) {
            let n = nume.split(' ')

            // console.log('n :>> ', n);

            let firstLetters = ''

            if (n[0]) {

                firstLetters += n[0].substring(0, 1)

            }
            if (n[1]) {
                firstLetters += n[1].substring(0, 1)
            }

            firstLetters = firstLetters.toUpperCase()

            return firstLetters
        } else {
            return 'NA'
        }


    }


    prezentInvoire = () => {

        let compareDates = this.m.jsDatesDifferenceInDays(this.u.defaultData(), this.props.dataInceput)


        console.log('compareDates :>> ', compareDates);

        let tipuriConcedii = [...this.props.tipuriConcedii]


        if (compareDates <= 0) {





            return [
                <option key={'prezent'} value={'prezent'}>Prezent</option>,
                tipuriConcedii.map((c, idx) => {
                    return (
                        <option key={idx} value={c.id}>{c.nume}</option>
                    )
                })
            ]
        } else {
            tipuriConcedii = tipuriConcedii.filter(tc => tc.id !== 'absenta_invoire' && tc.id !== 'invoire' && tc.id !== 'ore_suplimentare' && tc.id !== 'absenta_nemotivata')





            return [

                tipuriConcedii.map((c, idx) => {
                    return (
                        <option key={idx} value={c.id}>{c.nume}</option>
                    )
                })
            ]
        }
    }

    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    fullWidth={true}
                    maxWidth='xs'
                    open={this.props.open}
                    onClose={this.props.dialogClose}>
                    <DialogActions >
                        <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i className='material-icons pm-round-button-text-dialog'>close</i>
                        </Fab>
                    </DialogActions>
                    <DialogContent>
                        <Grid container>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid style={{ marginBottom: 20, marginTop: 20 }} container>
                                    <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                        <div style={{ width: 55 }}>
                                            <div
                                                style={{
                                                    backgroundColor: 'rgb(252 93	98)',
                                                    height: 14,
                                                    borderTopLeftRadius: 10,
                                                    borderTopRightRadius: 10,

                                                }}
                                            ></div>
                                            <div style={{
                                                borderBottomLeftRadius: 10,
                                                borderBottomRightRadius: 10,
                                                border: '3px solid rgb(231 231 231 )',
                                                borderTop: 'none',
                                                padding: 4
                                            }}>


                                                <span style={{
                                                    display: 'block',
                                                    textAlign: 'center',
                                                    fontSize: 16,
                                                    fontWeight: 600
                                                }}>{new Date(this.props.dataInceput).getDate()}</span>
                                                <span style={{
                                                    display: 'block',
                                                    textAlign: 'center',

                                                    textTransform: 'uppercase',
                                                    fontSize: 10
                                                }}>{this.u.luniPrescurtate[new Date(this.props.dataInceput).getMonth()]}</span>
                                            </div>

                                        </div>

                                    </Grid>
                                    <Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
                                        <Grid container>

                                            <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                {
                                                    this.u.poza &&
                                                    <div
                                                        className='pm-angajati-picture'

                                                        style={{ backgroundImage: `url('${this.props.angajat.poza ? (new Ws().adresaMedia + '/Angajati/' + this.props.angajat.poza) : avatar}')`, height: 36, width: 36, padding: 5 }}>

                                                    </div>
                                                }
                                                {!this.u.poza &&

                                                    <Avatar
                                                        className='pm-angajati-picture'
                                                        style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', height: 36, width: 36, backgroundColor: new Utils().culoriUtilizatori(this.props.angajat.id), padding: 5, cursor: 'pointer' }}>
                                                        {/* <i style={{ verticalAlign: '-webkit-baseline-middle', cursor: 'pointer' }} className='material-icons'>person</i> */}
                                                        <span style={{ display: 'block' }}>{this.numeAvatar(this.props.angajat.nume)} </span>
                                                    </Avatar>
                                                    // <Avatar onClick={this.props.userClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                                }
                                            </Grid>

                                            <Grid style={{ textAlign: 'left', paddingTop: 10, paddingLeft: 20 }} item xs={10} sm={10} md={10} lg={10} xl={10}>
                                                <span style={{ fontWeight: 700, fontSize: 14 }}>    {this.props.angajat.nume}</span><br />
                                                <span style={{
                                                    fontSize: 12,
                                                    color: '#9a9a9a'
                                                }}>{this.props.angajat.functie} - {this.props.angajat.departament}</span>

                                            </Grid>

                                        </Grid>
                                    </Grid>

                                </Grid>


                                <Divider className='pm-divider' />

                            </Grid>

                            {this.props.toUpdate &&

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>


                                    <Grid style={{ paddingTop: 20, paddingBottom: 20 }} container>
                                        <Grid style={{ textAlign: 'center' }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                            <div style={{ backgroundColor: this.props.eveniment.color, verticalAlign: 'middle', borderRadius: '50%', height: 24, width: 24, marginRight: 5 }} className='pm-task-legend'></div>
                                        </Grid>
                                        <Grid style={{ textAlign: 'left' }} item xs={7} sm={7} md={7} lg={7} xl={7}>
                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{this.props.eveniment.nume_concediu}</span>
                                            <span className='textSecondary' style={{ marginRight: 20, fontSize: 12, display: 'block', }}>

                                                {this.props.eveniment.cand_inceput_dataC && this.u.dataPrescurtataRomana(this.props.eveniment.cand_inceput_dataC) + ' - '}   {this.props.eveniment.cand_sfarsit_dataC && this.u.dataPrescurtataRomana(this.props.eveniment.cand_sfarsit_dataC)}</span>
                                            {this.props.eveniment.cand_inceput_oraC && `${this.props.eveniment.cand_inceput_oraC} - `} {this.props.eveniment.cand_sfarsit_oraC && this.props.eveniment.cand_sfarsit_oraC}
                                        </Grid>

                                        {(this.props.pontajDrepturi.sef_departament === 1 || this.props.pontajDrepturi.is_admin === 1) &&
                                            <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                {this.props.toUpdate &&  this.props.tipEveniment !== 'absenta_invoire' && this.props.tipEveniment !== 'invoire' && this.props.tipEveniment !== 'ore_suplimentare' && this.props.eveniment.prezent_azi !== 1 && this.props.eveniment.absent_azi !== 1 &&
                                                    <PenSolid className=' iconSvg' onClick={() => { this.setState({ editReady: !this.state.editReady }) }} style={{ marginRight: 0, width: 18, height: 18 }} />
                                                }
                                                <TrashAltSolid className=' iconSvg' onClick={() => { this.props.stergeEveniment(this.props.eveniment) }} style={{ marginLeft: 10, width: 18, height: 18 }} />
                                            </Grid>

                                        }


                                    </Grid>

                                    <Divider className='pm-divider' />


                                </Grid>

                            }



                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>



                                {!this.props.toUpdate &&

                                    <Grid container>
                                        <Grid style={{ marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <div style={{ position: 'relative', textAlign: 'center' }}>
                                                <select
                                                    id='tipEveniment'
                                                    style={{ width: '95%', paddingTop: 9, paddingBottom: 9 }}
                                                    className='add-project-input'
                                                    type="text"
                                                    margin="normal"
                                                    name='tva'
                                                    value={this.props.tipEveniment}
                                                    onChange={this.props.changeTip}
                                                    placeholder={this.dictionary.pontaje.tipEveniment}
                                                >

                                                    {this.prezentInvoire()}




                                                </select>
                                                <label style={{ marginLeft: 10 }} className='inputLabelPM' htmlFor='tipEveniment'>{this.dictionary.pontaje.tipEveniment}</label>
                                            </div>

                                        </Grid>


                                        {this.props.tipEveniment === 'absenta_invoire' &&
                                            <Grid style={{ textAlign: 'center', marginTop: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                <div style={{ position: 'relative' }}>
                                                    <input
                                                        style={{ fontSize: 12, fontWeight: 400, width: '95%' }}
                                                        id='totalNet'
                                                        type="time"
                                                        className='add-project-input'
                                                        margin="normal"
                                                        name='pret'
                                                        value={this.props.oraInceput}
                                                        onChange={this.props.changeOraInceput}
                                                    />
                                                    <label className='inputLabelPM' htmlFor='totalNet'>{this.dictionary.pontaje.oraIncepere}</label>


                                                </div>

                                            </Grid>
                                        }

                                        {this.props.tipEveniment === 'absenta_invoire' &&
                                            <Grid style={{ textAlign: 'center', marginTop: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                <div style={{ position: 'relative' }}>
                                                    <input
                                                        style={{ fontSize: 12, fontWeight: 400, width: '95%' }}
                                                        id='totalNet'
                                                        type="time"
                                                        className='add-project-input'
                                                        margin="normal"
                                                        name='pret'
                                                        value={this.props.oraFinalizare}
                                                        onChange={this.props.changeOraFinalizare}
                                                    />
                                                    <label className='inputLabelPM' htmlFor='totalNet'>{this.dictionary.pontaje.oraFinalizare}</label>


                                                </div>

                                            </Grid>
                                        }

                                        {this.props.tipEveniment === 'invoire' &&
                                            <Grid style={{ textAlign: 'center', marginTop: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                <div style={{ position: 'relative' }}>
                                                    <input
                                                        style={{ fontSize: 12, fontWeight: 400, width: '95%' }}
                                                        id='totalNet'
                                                        type="time"
                                                        className='add-project-input'
                                                        margin="normal"
                                                        name='pret'
                                                        value={this.props.oraInceput}
                                                        onChange={this.props.changeOraInceput}
                                                    />
                                                    <label className='inputLabelPM' htmlFor='totalNet'>{this.dictionary.pontaje.oraIncepere}</label>


                                                </div>

                                            </Grid>
                                        }

                                        {this.props.tipEveniment === 'invoire' &&
                                            <Grid style={{ textAlign: 'center', marginTop: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                <div style={{ position: 'relative' }}>
                                                    <input
                                                        style={{ fontSize: 12, fontWeight: 400, width: '95%' }}
                                                        id='totalNet'
                                                        type="time"
                                                        className='add-project-input'
                                                        margin="normal"
                                                        name='pret'
                                                        value={this.props.oraFinalizare}
                                                        onChange={this.props.changeOraFinalizare}
                                                    />
                                                    <label className='inputLabelPM' htmlFor='totalNet'>{this.dictionary.pontaje.oraFinalizare}</label>


                                                </div>

                                            </Grid>
                                        }

                                        {this.props.tipEveniment === 'ore_suplimentare' &&
                                            <Grid style={{ textAlign: 'center', marginTop: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                <div style={{ position: 'relative' }}>
                                                    <input
                                                        style={{ fontSize: 12, fontWeight: 400, width: '95%' }}
                                                        id='totalNet'
                                                        type="time"
                                                        className='add-project-input'
                                                        margin="normal"
                                                        name='pret'
                                                        value={this.props.oraInceput}
                                                        onChange={this.props.changeOraInceput}
                                                    />
                                                    <label className='inputLabelPM' htmlFor='totalNet'>{this.dictionary.pontaje.oraIncepere}</label>


                                                </div>

                                            </Grid>
                                        }

                                        {this.props.tipEveniment === 'ore_suplimentare' &&
                                            <Grid style={{ textAlign: 'center', marginTop: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                <div style={{ position: 'relative' }}>
                                                    <input
                                                        style={{ fontSize: 12, fontWeight: 400, width: '95%' }}
                                                        id='totalNet'
                                                        type="time"
                                                        className='add-project-input'
                                                        margin="normal"
                                                        name='pret'
                                                        value={this.props.oraFinalizare}
                                                        onChange={this.props.changeOraFinalizare}
                                                    />
                                                    <label className='inputLabelPM' htmlFor='totalNet'>{this.dictionary.pontaje.oraFinalizare}</label>


                                                </div>

                                            </Grid>
                                        }


                                        {this.props.tipEveniment === 'prezent' &&
                                            <Grid style={{ textAlign: 'center', marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <div style={{ position: 'relative' }}>
                                                    <input
                                                        style={{ fontSize: 12, fontWeight: 400, width: '95%' }}
                                                        id='totalNet'
                                                        type="date"
                                                        className='add-project-input'
                                                        margin="normal"
                                                        name='pret'
                                                        value={this.props.dataInceput}
                                                        onChange={this.props.changeDataInceput}
                                                    />
                                                    <label className='inputLabelPM' htmlFor='totalNet'>{this.dictionary.pontaje.dataEveniment}</label>


                                                </div>

                                            </Grid>

                                        }

                                        {this.props.tipEveniment === 'absenta_nemotivata' &&
                                            <Grid style={{ textAlign: 'center', marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <div style={{ position: 'relative' }}>
                                                    <input
                                                        style={{ fontSize: 12, fontWeight: 400, width: '95%' }}
                                                        id='totalNet'
                                                        type="date"
                                                        className='add-project-input'
                                                        margin="normal"
                                                        name='pret'
                                                        value={this.props.dataInceput}
                                                        onChange={this.props.changeDataInceput}
                                                    />
                                                    <label className='inputLabelPM' htmlFor='totalNet'>{this.dictionary.pontaje.dataEveniment}</label>


                                                </div>

                                            </Grid>

                                        }


                                        {this.props.tipEveniment === 'absenta_invoire' &&
                                            <Grid style={{ textAlign: 'center', marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <div style={{ position: 'relative' }}>
                                                    <input
                                                        style={{ fontSize: 12, fontWeight: 400, width: '95%' }}
                                                        id='totalNet'
                                                        type="date"
                                                        className='add-project-input'
                                                        margin="normal"
                                                        name='pret'
                                                        value={this.props.dataInceput}
                                                        onChange={this.props.changeDataInceput}
                                                    />
                                                    <label className='inputLabelPM' htmlFor='totalNet'>{this.dictionary.pontaje.dataEveniment}</label>


                                                </div>

                                            </Grid>

                                        }


                                        {this.props.tipEveniment === 'invoire' &&
                                            <Grid style={{ textAlign: 'center', marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <div style={{ position: 'relative' }}>
                                                    <input
                                                        style={{ fontSize: 12, fontWeight: 400, width: '95%' }}
                                                        id='totalNet'
                                                        type="date"
                                                        className='add-project-input'
                                                        margin="normal"
                                                        name='pret'
                                                        value={this.props.dataInceput}
                                                        onChange={this.props.changeDataInceput}
                                                    />
                                                    <label className='inputLabelPM' htmlFor='totalNet'>{this.dictionary.pontaje.dataEveniment}</label>


                                                </div>

                                            </Grid>

                                        }


                                        {this.props.tipEveniment === 'ore_suplimentare' &&
                                            <Grid style={{ textAlign: 'center', marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <div style={{ position: 'relative' }}>
                                                    <input
                                                        style={{ fontSize: 12, fontWeight: 400, width: '95%' }}
                                                        id='totalNet'
                                                        type="date"
                                                        className='add-project-input'
                                                        margin="normal"
                                                        name='pret'
                                                        value={this.props.dataInceput}
                                                        onChange={this.props.changeDataInceput}
                                                    />
                                                    <label className='inputLabelPM' htmlFor='totalNet'>{this.dictionary.pontaje.dataEveniment}</label>


                                                </div>

                                            </Grid>

                                        }

                                        {this.props.tipEveniment !== 'absenta_nemotivata' && this.props.tipEveniment !== 'prezent' && this.props.tipEveniment !== 'absenta_invoire' && this.props.tipEveniment !== 'invoire' && this.props.tipEveniment !== 'ore_suplimentare' &&
                                            <Grid style={{ textAlign: 'center', marginTop: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                <div style={{ position: 'relative' }}>
                                                    <input
                                                        style={{ fontSize: 12, fontWeight: 400, width: '90%' }}
                                                        id='totalNet'
                                                        type="date"
                                                        className='add-project-input'
                                                        margin="normal"
                                                        name='pret'
                                                        value={this.props.dataInceput}
                                                        onChange={this.props.changeDataInceput}
                                                    />
                                                    <label className='inputLabelPM' htmlFor='totalNet'>{this.dictionary.pontaje.dataInceput}</label>


                                                </div>

                                            </Grid>

                                        }

                                        {this.props.tipEveniment !== 'absenta_nemotivata' && this.props.tipEveniment !== 'prezent' && this.props.tipEveniment !== 'absenta_invoire' && this.props.tipEveniment !== 'invoire' && this.props.tipEveniment !== 'ore_suplimentare' &&
                                            <Grid style={{ textAlign: 'center', marginTop: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                <div style={{ position: 'relative' }}>
                                                    <input
                                                        style={{ fontSize: 12, fontWeight: 400, width: '90%' }}
                                                        id='totalNet'
                                                        type="date"
                                                        className='add-project-input'
                                                        margin="normal"
                                                        name='pret'
                                                        value={this.props.dataSfarsit}
                                                        onChange={this.props.changeDataSfarsit}
                                                    />
                                                    <label className='inputLabelPM' htmlFor='totalNet'>{this.dictionary.pontaje.dataSfarsit}</label>


                                                </div>
                                            </Grid>
                                        }



                                    </Grid>


                                }


                                {this.props.toUpdate && this.state.editReady && this.props.tipEveniment !== 'absenta_invoire' && this.props.tipEveniment !== 'invoire' && this.props.tipEveniment !== 'ore_suplimentare' && this.props.eveniment.prezent_azi !== 1 && this.props.eveniment.absent_azi !== 1 &&

                                    <Grid container>

                                        <Grid style={{ textAlign: 'center', marginTop: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                            <div style={{ position: 'relative' }}>
                                                <input
                                                    style={{ fontSize: 12, fontWeight: 400, width: '90%' }}
                                                    id='totalNet'
                                                    type="date"
                                                    className='add-project-input'
                                                    margin="normal"
                                                    name='pret'
                                                    value={this.props.dataInceput}
                                                    onChange={this.props.changeDataInceput}
                                                />
                                                <label className='inputLabelPM' htmlFor='totalNet'>{this.dictionary.pontaje.dataInceput}</label>


                                            </div>

                                        </Grid>




                                        <Grid style={{ textAlign: 'center', marginTop: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                            <div style={{ position: 'relative' }}>
                                                <input
                                                    style={{ fontSize: 12, fontWeight: 400, width: '90%' }}
                                                    id='totalNet'
                                                    type="date"
                                                    className='add-project-input'
                                                    margin="normal"
                                                    name='pret'
                                                    value={this.props.dataSfarsit}
                                                    onChange={this.props.changeDataSfarsit}
                                                />
                                                <label className='inputLabelPM' htmlFor='totalNet'>{this.dictionary.pontaje.dataSfarsit}</label>


                                            </div>
                                        </Grid>







                                    </Grid>

                                }




                            </Grid>

                            {this.props.toUpdate &&
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <span>{this.props.existaPontaj}</span>
                                    <Button
                                        style={{ width: '100%', marginTop: 20 }}
                                        disabled={!this.state.editReady}
                                        className={!this.state.editReady ? 'add-button-disabled' : 'add-button-green'} onClick={this.props.adaugaEvenimentNou}  >

                                        {this.dictionary.pontaje.adaugaEvenimentul}
                                    </Button>
                                </Grid>
                            }

                            {!this.props.toUpdate &&
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <span>{this.props.existaPontaj}</span>
                                    <Button
                                        style={{ width: '100%', marginTop: 20 }}

                                        className={'add-button-green'} onClick={this.props.adaugaEvenimentNou}  >

                                        {this.dictionary.pontaje.adaugaEvenimentul}
                                    </Button>
                                </Grid>
                            }



                        </Grid>
                    </DialogContent>


                </Dialog>
            </div >
        );
    }
}